import { isMedianMetric } from 'views/root/views/home/views/performance/views/CustomReport/custom-report.util';

export const parseFiltersToMetricsConfig = ({
  metricName,
  filters,
  metricsCalculationStrategy,
  graph
}) => {
  const isAggMetric = isMedianMetric(metricName);
  const widget = graph;

  const { repo, contributor, service, team, label } = filters;

  const metricConfig = {
    id: widget?.id ?? -1,
    name: metricName,
    unitType: widget?.unitType ?? '',
    formattedName: widget?.name ?? '',
    ...(isAggMetric && { agg: metricsCalculationStrategy }),
    unitDescription: widget?.unitDescription ?? ''
  };

  const metricsConfig = [
    {
      ...metricConfig,
      isMainKey: true,
      filtersOverrides: {
        ...(contributor && {
          contributor_ids: [contributor.id]
        }),
        ...(team && {
          team_ids: [team.id]
        }),
        ...(repo?.length && {
          repository_ids: repo.map(({ id }) => id)
        }),
        ...(service?.length && {
          service_ids: service.map(({ id }) => id)
        }),
        ...(label && {
          labels: [label]
        })
      }
    }
  ];

  return metricsConfig;
};
